import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@app/componentlib/src/store'
import { convertPropertyNames } from '@app/componentlib/src/application/helpers/convertPropNames'
export interface IAppState {
  _initialized: boolean
  _portalSettings: PortalSettings
  _translations: Object
  _isMobile: boolean
}

export interface PortalSettings {
  profileLink?: string
}

@Module({
  dynamic: true,
  store,
  name: 'app',
  namespaced: true
})
class App extends VuexModule implements IAppState {
  _initialized = false
  _portalSettings: PortalSettings = {}
  _translations: object = {}
  _isMobile = false

  @Action({ rawError: true })
  async init () {
    console.log('APP: Initialized')
    this.context.commit('SET_INITIALIZED', true)
  }

  @Action({ rawError: true })
  async changePortalSettings (settings: PortalSettings) {
    console.log('PORTAL SETTINGS: Updated')
    this.context.commit('SET_PORTALSETTINGS', settings)
  }

  @Action({ rawError: true })
  async setTranslations (translations: object) {
    console.log('PORTAL TRANSLATIONS: Updated', translations)
    this.context.commit('SET_TRANSLATIONS', translations)
  }

  @Action({ rawError: true })
  async setIsMobile(width: number) {

    if(width >= 768) {
      this.SET_ISMOBILE(false)
    } else {
      this.SET_ISMOBILE(true)
    }
  }

  @Mutation
  SET_INITIALIZED (val: boolean) {
    this._initialized = val
  }
  @Mutation
  SET_PORTALSETTINGS (settings: PortalSettings) {
    this._portalSettings = settings
  }
  @Mutation
  SET_TRANSLATIONS (obj: object) {
    this._translations = obj
  }

  @Mutation
  SET_ISMOBILE (value: boolean) {
    this._isMobile = value
  }

  //Getters
  get initialized (): boolean {
    return this._initialized
  }
  get portalSettings (): PortalSettings {
    return this._portalSettings
  }
  get translations (): object {
    return convertPropertyNames(this._translations)
  }
  get isMobile (): boolean {
    return this._isMobile
  }
}

export const AppModule = getModule(App)

